
<div class="main-container">
  @if (showChrome()) {
  <app-header></app-header>
  
  }
    <app-system-lock-banner></app-system-lock-banner>

  <div class="main-body-row">
    @if (showChrome()) {
    <app-main-nav></app-main-nav>

    <div #globalTabs class="global-tab-column"></div>
    }

    <div class="sub-body"
         [class.main-nav-collapsed]="
        showChrome() && !sidenavService.isExpanded('main')
      ">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
